export default {
  USER_HID_BANNER: {
    name: 'UHB',
    options: {
      path: '/',
      maxAge: 24 * 60 * 60, // day
      secure: true,
      httpOnly: false,
    },
  },
  EXCLUDED_ENTRY_POINT: {
    name: 'EEP',
    options: {
      path: '/',
      maxAge: 24 * 60 * 60, // day
      secure: true,
      httpOnly: false,
    },
  },
  ORDER_WAS_PLACED: {
    name: 'OWP',
    options: {
      path: '/',
      maxAge: 365 * 30 * 24 * 60 * 60, // year
      secure: true,
      httpOnly: false,
    },
  },
};
